import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team';
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units); 
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if (teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };
    
    const administration = teams.find((x) => x.id === 8);
    addUnits(administration);

    const vejomraadet = teams.find((x) => x.id === 9);
    addUnits(vejomraadet);

    const vej = teams.find((x) => x.id === 185);
    addUnits(vej);

    const gronvej = teams.find((x) => x.id === 11);
    addUnits(gronvej);

    const komunaleEjendome = teams.find((x) => x.id === 10);
    addUnits(komunaleEjendome);

    const team2 = teams.find((x) => x.id === 180);
    addUnits(team2);

    const team3 = teams.find((x) => x.id === 181);
    addUnits(team3);

    const tvear = teams.find((x) => x.id === 182);
    addUnits(tvear);

    const vearkstedOgGenbrug = teams.find((x) => x.id === 183);
    addUnits(vearkstedOgGenbrug);

    const genbrug = teams.find((x) => x.id === 184);
    addUnits(genbrug);

    return (
        <div className="team-list">
            {administration && 
                <Team 
                    team={administration} 
                    width={11} 
                />
            }
            {vejomraadet && 
                <Team 
                    team={vejomraadet} 
                    width={21} 
                    subTeams={[vej]} 
                />
            }
            {gronvej && 
                <Team 
                    team={gronvej} 
                    width={13} 
                />
            }
            {komunaleEjendome && 
                <Team 
                    team={komunaleEjendome} 
                    width={39} 
                    subTeams={[team2, team3]} 
                />
            }
            {vearkstedOgGenbrug && 
                <Team 
                    team={vearkstedOgGenbrug} 
                    width={16} 
                    subTeams={[genbrug]} 
                />
            }
            <ColorLegend />
        </div>
    );
};

export default CustomTeamList;